import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { PromotionsForPrime: { getPromotionsForPrime } } = apiUrls;

export const PROMOTIONS_FOR_PRIME_SUCCESS = 'PROMOTIONS_FOR_PRIME_SUCCESS';
export const PROMOTIONS_FOR_PRIME_LOADING = 'PROMOTIONS_FOR_PRIME_LOADING';

export const getPromotionsForPrimeData = ({ fromDate, toDate }) => async (dispatch) => {
    try {
        const { url } = getPromotionsForPrime
        const requestData = {
            ...getPromotionsForPrime,
            url: url.replace('{{fromdate}}', fromDate).replace('{{todate}}', toDate)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: PROMOTIONS_FOR_PRIME_SUCCESS,
            data,
        })

    } catch (e) {

        dispatch({
            type: PROMOTIONS_FOR_PRIME_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: PROMOTIONS_FOR_PRIME_LOADING,
        isLoading
    });
}